import React from "react";  
import CargoShipmentReportListKmPageContainer from "./CargoShipmentReportListKmPageContainer";

 export class CargoShipmentReportKmListPage extends React.Component {
  render() {
    return <CargoShipmentReportListKmPageContainer {...this.props} />;
  }
}
